<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page :title="decodeURI(this.cari.title)">
            <w-form ref="dform" @validate="search">
                
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_dari"
                            required
                            label="Dari"
                            type="date"
                        />
                    </div>
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                    </div>
                </w-flex>

            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button class="ml1" v-on:click="goback()" bg-color="success">
                        <w-icon>fal fa-arrow-left</w-icon>&nbsp;Kembali
                    </w-button>
                    <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1 " @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <center v-if="!table.meta.current_page"><w-progress class="ma1" circle></w-progress></center>
            <z-table
                ref="tbluser"
                title=""
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
            </z-table>
            <!-- <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>BIL</td>
                                <td v-if="cari.type == 'd'">TARIKH BAYAR</td>
                                <td v-else>TARIKH LULUS</td>
                                <td v-if="cari.type == 'd'">NO. RESIT</td>
                                <td v-else>NO. PENYATA PEMUNGUT</td>
                                <td v-if="cari.type == 'a'">NO. RESIT PERBENDAHARAAN</td>
                                <td v-if="cari.type == 'c'">FAIL ISPEKS</td>
                                <td v-if="cari.type == 'd'">PENYATA PEMUNGUT</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.items">
                                <td>{{ index+1 }}</td>
                                <td v-if="cari.type == 'd'">{{ dt.tarikh_bayar }}</td>
                                <td v-else>{{ dt.tarikh }}</td>
                                <td v-if="cari.type == 'd'">{{ dt.no_resit }}</td>
                                <td v-else>{{ dt.no_penyata_pemungut }}</td>
                                <td v-if="cari.type == 'a'">{{ dt.no_resit_perbendaharaan }}</td>
                                <td v-if="cari.type == 'c'">{{ dt.jana_fail_respon }}</td>
                                <td v-if="cari.type == 'd'">{{ dt.penyata_pemungut_id }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <w-card class="text-right">
                        <w-flex
                            v-if="table.meta.current_page"
                            class="justify-start align-center"
                        >
                            <pagination
                                class="xs11"
                                :max="table.meta.last_page"
                                :path="table.meta.path"
                                :current="table.meta.current_page"
                                :last_page="table.meta.last_page"
                                :links="table.meta.links"
                                @pageChanged="table.loadpg"
                            />
                        </w-flex>
                    </w-card>
                </div>
            </w-flex> -->
        

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
    auth: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_laporan+'kutipan/laporan/interim_lv2',
        reload: true,
        loading: false,
        status: [
            {
                value: 1,
                label: 'Aktif',
            },
            {
                value: 2,
                label: 'Tidak Aktif',
            },
        ],
        crumbs: [
            { label: 'iHasil', route: '/' },
            { label: 'Laporan Interim', route: '/kutipan/laporan/interim' },
          ],
          cari : {tarikh_dari: '', tarikh_hingga: '', type: '', title: 'LAPORAN INTERIM'},
          }
  },
  methods: {

    search() {
        this.getDataQuery();
    //   this.$inertia.visit(window.route('akaun_belum_terima.abt_1b')+'?bulan='+this.cari.bulan+'&tahun='+this.cari.tahun, {preserveScroll:true})
    },

    goback() {
        this.$inertia.visit(window.route('kutipan.laporan.interim')+'?tarikh_dari='+this.cari.tarikh_dari+'&tarikh_hingga='+this.cari.tarikh_hingga+'&goback=true', {preserveScroll:true})
    },
    reset(){
      this.cari = {bulan: '', tahun: ''}
      this.search()
    },
    cetak() {
            window.open(this.service_laporan+'kutipan/laporan/interim_lv2?cetak=true&user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga + 
            "&type=" + this.cari.type + "&title=" + this.cari.title,'_blank');
        },
  },
  watch: {
  },
  mounted() {
    // override default setting
    // this.getData();
    this.dialog.width = 900
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari.tarikh_dari == 'undefined'){this.cari.tarikh_dari = ''}
    if(this.cari.tarikh_hingga == 'undefined'){this.cari.tarikh_hingga = ''}
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>